export default "__VITE_ASSET__COYHmfys__"